import { h } from 'preact'
import { BaseAnnotation } from '../base_annotation';

export class Stylesheet extends BaseAnnotation {
    render () {
        const { contentType = '', content = '' } = this.props;

        if (contentType === "url" && content.length) {
            return <link rel="stylesheet" type="text/css" href={content}/>
        }

        if (contentType === "text" && content) {
            return <style type="text/css">{content}</style>
        }

        return null;
    }
}